import { render, staticRenderFns } from "./ArenaSignUpdateSignerRole.vue?vue&type=template&id=49c8d101&"
import script from "./ArenaSignUpdateSignerRole.vue?vue&type=script&lang=ts&"
export * from "./ArenaSignUpdateSignerRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports